import pulse from '@finn-no/pulse-sdk';

// TJT_ev80 (Seller) View of the "do KYC" infobox.
export enum ObjectNameKycBox {
    KYC_NOT_STARTED = 'KYC not started',
    KYC_COMPLETED = 'KYC completed',
}

const getPosition = (entryPoint: 'AD_ADMIN' | 'TRANSACTION_OVERVIEW') => {
    switch (entryPoint) {
        case 'AD_ADMIN':
            return 'Ad management';
        case 'TRANSACTION_OVERVIEW':
            return 'Transaction center';
        default:
            console.warn('Non-valid entry point: ', entryPoint);
    }
}

const trackPageViewKycBox = (name: ObjectNameKycBox, entryPoint: 'AD_ADMIN' | 'TRANSACTION_OVERVIEW') =>
    pulse.trackPageView({
        type: 'View',
        intent: 'Show',
        name: 'KYC nudge to enable Buy Now',
        object: {
            id: 'TJT_ev80',
            type: 'UIElement',
            elementType: 'Tip module',
            position: getPosition(entryPoint),
            name,
        },
        target: {
            id: window.location.href,
            type: 'Form',
            name: 'KYC',
        },
        vertical: {
            name: 'Recommerce',
            subVertical: 'transaction_journey_recommerce',
        },
    });

// TJT_ev81 Click on the button to begin the KYC process and enable Buy Now
const trackStartButtonKycBox = (entryPoint: 'AD_ADMIN' | 'TRANSACTION_OVERVIEW') =>
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'KYC nudge to enable Buy Now',
        object: {
            id: 'TJT_ev81',
            type: 'UIElement',
            elementType: 'Button',
            position: getPosition(entryPoint),
        },
        target: {
            id: window.location.href,
            type: 'Form',
            name: 'KYC',
        },
        vertical: {
            name: 'Recommerce',
            subVertical: 'transaction_journey_recommerce',
        },
    });

const pulseClient = {
    trackPageViewKycBox,
    trackStartButtonKycBox,
};

export default pulseClient;
